/// <reference types="jasmine" />
import { UntypedFormControl, NgControl } from '@angular/forms';

export class NgControlMock extends NgControl {
  viewToModelUpdate = jasmine.createSpy('viewToModelUpdate');
  control = new UntypedFormControl();
}
